import isNil from 'lodash/isNil'

export const getTestAttributes = (module, description, element, id) => {

  if(typeof module === "object") {
    return { id: module.id };
  }

  return { id: `${module}-${description}${element ? '-' + element : ''}${isNil(id) ? '' : '-' + id}` };
};